module.exports = __webpack_public_path__ + "img/logo-MasterCard.5450f163.svg";